import { StorageDocumentoStatus } from '@/types'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { VChip } from 'vuetify/lib'

@Component({})
export class ChipSituacaoDocumento extends Vue {
	@Prop({ type: Number, required: true }) status!: number
	public render() {
		return (
			<VChip small text-color={this.colors?.textColor} color={this.colors?.color}>
				{this.text}
			</VChip>
		)
	}

	get text() {
		switch (this.status) {
			case StorageDocumentoStatus.APPROVED:
				return 'Aprovado'
			case StorageDocumentoStatus.DENIED:
				return 'Reprovado'
			case StorageDocumentoStatus.SENT:
				return 'Em Análise'
			case StorageDocumentoStatus.REQUESTED:
				return 'Socilitado'
			case StorageDocumentoStatus.CANCELED:
				return 'Cancelado'
		}
	}

	get colors() {
		switch (this.status) {
			case StorageDocumentoStatus.APPROVED:
				return {
					color: '#E3F3E4',
					textColor: '#41AC4B'
				}
			case StorageDocumentoStatus.DENIED:
				return {
					color: '#FBE3E3',
					textColor: '#E54646'
				}
			case StorageDocumentoStatus.SENT:
				return {
					color: '#E8F1E7',
					textColor: '#245825'
				}
			case StorageDocumentoStatus.REQUESTED:
				return {
					color: '#FEF7DC',
					textColor: '#F9C716',
					text: 'Socilitado'
				}
			case StorageDocumentoStatus.CANCELED:
				return {
					color: '#DFE1E6',
					textColor: '#4D4D4D',
					text: 'Cancelado'
				}
		}
	}
}

export default ChipSituacaoDocumento
